module.exports = __webpack_public_path__ + "static/media/medicalstaff.9b4225b7.png";